import {
  AnchoredPanelComponent,
  BookmarkablePage,
  FullPagePanel,
  MessageType,
  PanelMessage,
  useNavigation,
} from "o4a-react";
import * as React from "react";
import { useLocation } from "react-router-dom";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { FilterState, FilterStateContext } from "../../console/FilterContext";
import { PageId, PageRegistrationConfig, SUPPORT_ROUTE } from "../../constants/pluginConstants";
import { SvgIconIds } from "../../constants/uiConstants";
import { RoleBasedAction } from "../../helpers/roleHelper";
import { useRoles } from "../../hooks/useRoles";
import { SupportList } from "./SupportList";

const registrationIds = PageRegistrationConfig[PageId.SUPPORT].map(config => config.key);

export const SupportListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);
  const { pathname } = useLocation();
  const filterState = React.useContext<FilterState>(FilterStateContext);

  const [panelRef, setPanelRef] = React.useState<AnchoredPanelComponent>({} as AnchoredPanelComponent);

  const { isActionAllowed, actionRequiredRoles } = useRoles();
  const disableList = !isActionAllowed(RoleBasedAction.LIST_SUPPORT);
  const requiredRole = actionRequiredRoles(RoleBasedAction.LIST_SUPPORT)[0]?.displayName;

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(SUPPORT_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (filterState.pillFilterStateValue.listId !== pathname) {
      filterState.setFilterStateValue({ filterValues: undefined, listId: undefined, defaultPills: undefined });
      filterState.setFilterTextValue(undefined);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listSupport.titles.short()}
    >
      <FullPagePanel
        componentRef={setPanelRef}
        title={Messages.listSupport.titles.long()}
        icon={SvgIconIds.supportSvg}
        message={disableList
          ? {
            type: MessageType.WARNING,
            text: Messages.validation.roleMissingForList(requiredRole),
          } as PanelMessage
          : undefined}
        onClose={back}
        isOpen
      >
        <SupportList panelRef={panelRef} disabled={disableList} />
      </FullPagePanel>
    </BookmarkablePage>
  );
};
